import React, { useEffect, useState } from "react";
import ModalForm from "../DynamicForm/ModalForm";

import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { useSelector } from "react-redux";
import { useTheme } from "../BrandColors/Context/ThemeContext";


const TableComponent = ({ activeIndex, data, onActionClick, currentIndex, setCurrentIndex, setSentences, formData, setFormData, selectedSentence, setSelectedSentence, tableIndex, setTableIndex, steps, setSteps, }) => {
  const multiStepProcessId = useSelector((state) => state.auth.multiStepProcessId)
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  console.log(multiStepProcessId, 'multiss')
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showAddNotepadBtn, setshowAddNotepadBtn] = useState(true);
  // const [selectedSentence, setSelectedSentence] = useState(null);
  const [editIndex, setEditIndex] = useState(null); // To track the index being edited
  const theme = useTheme() || "#3b82f6";
  console.log('selectesdsen', selectedSentence)
  console.log(steps)
  // Handle Add Notepad Button Click
  const handleAddNotepadClick = (tableIndex, index) => {
    // console.log(tableData[tableIndex].notepadData)
    console.log(currentIndex, 'currentIndex')
    setCurrentIndex(index)
    setTableIndex(tableIndex)
    setSelectedSentence(steps[tableIndex]?.boardData[index]?.sentence);
    setIsModalOpen(true);
  };
  console.log('shshsh', showAddNotepadBtn)


  console.log("tabledata", steps)

  // Handle Delete Action
  const handleDelete = (tableIndex, boardindex) => {
    // const updatedData = tableData.filter((_, i) => i !== index);
    const updatedData = steps[tableIndex]?.boardData
    const filteredBoardData = updatedData.filter((item, index) => index !== boardindex)
    console.log('filtered', filteredBoardData);
    // setSentences(filteredBoardData)

    setSteps((prevsteps) => {
      return prevsteps.map((item, index) => {
        if (index === tableIndex) {
          return { ...item, boardData: filteredBoardData }
        }
        else {
          return item
        }
      })
    })
    // setSteps(filteredData);
  };

  // Handle Edit Action
  const handleEdit = (tableindex, boardindex) => {
    setEditIndex(boardindex);
    setCurrentIndex(boardindex)
    setTableIndex(tableindex)
    setSelectedSentence(steps?.[tableindex]?.boardData[boardindex]?.sentence); // Set the selected data for editing
    let notepadData = steps?.[tableindex]?.boardData?.[boardindex]?.notepadData
    console.log(notepadData, 'dtaa')
    setFormData(notepadData)
    setIsModalOpen(true); // Open the modal for editing
  };

  // Handle Modal Form Submit
  const handleFormSubmit = (updatedSentence) => {
    if (editIndex !== null) {
      // Update the existing item
      const updatedData = [...steps];
      updatedData[editIndex] = updatedSentence;
      setSteps(updatedData);
      setEditIndex(null); // Reset the edit index
    } else {
      // Add new item
      setSteps([...steps, updatedSentence]);
    }
    setIsModalOpen(false);
  };

  return (
    <div className="w-full bg-blue-50/50 rounded-2xl border border-blue-200/50 overflow-hidden shadow-xl animate-fade-in-up">
      <div className="overflow-x-auto scrollbar-hide">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-white/80 border-b border-blue-200/50">
              <th className="px-6 py-4 text-sm font-semibold text-slate-700 w-16">No</th>
              <th className="px-6 py-4 text-sm font-semibold text-slate-700 min-w-[300px]">Sentence</th>
              <th className="px-6 py-4 text-sm font-semibold text-slate-700 w-48 text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            {steps.map((stepItem, tableindex) => {
              if (activeIndex !== tableindex) return null;
              
              const currentSentences = stepItem?.boardData?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage) || [];
              
              return currentSentences.map((item, localIndex) => {
                const boardindex = (currentPage - 1) * itemsPerPage + localIndex;
                return (
                <tr key={boardindex} className="border-b border-blue-200/50 hover:bg-white/5 transition-colors group">
                  <td className="px-6 py-4 text-sm text-slate-600 font-medium">
                    <span className="w-6 h-6 rounded-full bg-white flex items-center justify-center text-xs">
                      {boardindex + 1}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm text-slate-800 leading-relaxed">
                    {item.sentence}
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center justify-center gap-3">
                      {(!item?.boardDataAdded) && (
                        <button
                          onClick={() => handleAddNotepadClick(tableindex, boardindex)}
                          className="px-4 py-1.5 rounded-lg text-xs font-semibold text-white shadow-md transition-transform hover:-translate-y-0.5 active:translate-y-0"
                          style={{ backgroundColor: theme }}
                        >
                          Add Notepad
                        </button>
                      )}
                      
                      {(item?.boardDataAdded) && (
                        <>
                          <button
                            onClick={() => handleEdit(tableindex, boardindex)}
                            className="w-8 h-8 rounded-lg flex items-center justify-center bg-blue-500/10 text-blue-400 hover:bg-blue-500/20 hover:text-blue-300 transition-colors border border-blue-500/20"
                            title="Edit"
                          >
                            <FaEdit className="w-4 h-4" />
                          </button>
                          <button
                            onClick={() => handleDelete(tableindex, boardindex)}
                            className="w-8 h-8 rounded-lg flex items-center justify-center bg-red-500/10 text-red-400 hover:bg-red-500/20 hover:text-red-300 transition-colors border border-red-500/20"
                            title="Delete"
                          >
                            <MdDelete className="w-4 h-4" />
                          </button>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              );
              });
            })}
          </tbody>
        </table>
      </div>

      {steps[activeIndex]?.boardData?.length > 0 && (
        <div className="flex justify-center items-center gap-4 mt-6 pb-6">
            <button
                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                className="px-4 py-2 rounded-lg font-medium text-slate-700 bg-white hover:bg-blue-100 border border-blue-200 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
                Prev
            </button>
            <span className="text-slate-600 font-medium">
                Page <span className="text-white">{currentPage}</span> of <span className="text-white">{Math.ceil((steps[activeIndex]?.boardData?.length || 0) / itemsPerPage)}</span>
            </span>
            <button
                onClick={() => setCurrentPage(prev => Math.min(prev + 1, Math.ceil((steps[activeIndex]?.boardData?.length || 0) / itemsPerPage)))}
                disabled={currentPage === Math.ceil((steps[activeIndex]?.boardData?.length || 0) / itemsPerPage)}
                className="px-4 py-2 rounded-lg font-medium text-slate-700 bg-white hover:bg-blue-100 border border-blue-200 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
                Next
            </button>
        </div>
      )}

      {/* Modal Form */}
      {isModalOpen && (
        <ModalForm
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          steps={steps}
          // setSentences={setSentences}
          setshowAddNotepadBtn={setshowAddNotepadBtn}
          showAddNotepadBtn={showAddNotepadBtn}
          setSteps={setSteps}
          onSubmit={handleFormSubmit} // Handle form submit
          formData={formData}
          setFormData={setFormData}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          tableIndex={tableIndex}
          setTableIndex={setTableIndex}
        />
      )}
    </div>
  );
};

export default TableComponent;
